// utils/loadScripts.js

export const loadScript = (src, isAsync = true) => {
    return new Promise<void>((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve(); // Script already loaded
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = isAsync;
        script.src = src;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

        document.head.appendChild(script);
    });
};

export const loadInlineScript = (code) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = code;
    document.head.appendChild(script);
};

export const loadNoScriptPixel = (pixelUrl) => {
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="${pixelUrl}" />`;
    document.body.appendChild(noscript);
};

export const getScripts = (isGB) => {
    // Load PayPal SDK
    loadScript(`https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}`);

    if (isGB) {
        // Load Klaviyo (Only if hostCheck.isGB is true)
        loadScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=YvQtqY');

        // Load Facebook Pixel
        loadInlineScript(`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1388989812483964');
            fbq('track', 'PageView');
        `);

        // Load NoScript Pixel for Facebook
        loadNoScriptPixel('https://www.facebook.com/tr?id=1388989812483964&ev=PageView&noscript=1');
    }

}
